define('Group.CartDetailed', [
    'Group.CartDetailed.View'
], function(
    GroupCartDetailedView
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container){

            }

        }
        
        
    });
                 
